app.controller('SystemApi', function($scope, $http, _$toast, $rootScope, systemApiService, _$privileges) {

    $scope.showLoader = true;

    $scope.data = {
        "can_write": _$privileges.write("admin"),
        "notifications": [],
        "notification_filter": []
    };

    $scope.rows = [];

    $scope.filters = {
        "name": {
            model: {
                value: "",
                symbol: "text"
            }
        },
        "login": {
            model: {
                value: "",
                symbol: "text"
            }
        },
        "notification": []
    };

    $scope.clearFilters = function() {
        $scope.filters.name.value = "";
        $scope.filters.login.value = "";
        $scope.filters.notification.value = [];
        $scope.pagination.currentPage = 1;
        $scope._init();
    };

    /*
     * pagination
     */

    $scope.pagination = {
        currentPage: 1,
        totalItems: 1,
        itemsPerPage: 1
    };

    $scope._init = function() {
        var filters = {
            "name": typeof $scope.filters.name.value != "undefined" ? $scope.filters.name.value : "",
            "login": typeof $scope.filters.login.value != "undefined" ? $scope.filters.login.value : "",
            "notification": typeof $scope.filters.notification.value != "undefined" && $scope.filters.notification.value != null ? $scope.filters.notification.value.join(",") : "",
            "page": $scope.pagination.currentPage
        };

        var promise = systemApiService.list($scope.pagination.currentPage, filters);
        promise.success(function(result) {
            $scope.data.notifications = result.notifications;
            $scope.rows = result.list.data;
            $scope.showLoader = false;
            $scope.data.notification_filter = result.notification_filter;

            $scope.pagination = {
                totalItems: result.list.total,
                currentPage: result.list.current_page,
                itemsPerPage: result.list.per_page
            };
        });
    };

    $scope._init();

    $scope.hasNotification = function(notif, notifications) {
        var has = false;
        for (var i = 0; i < notifications.length; i++) {
            if (notif.id == notifications[i].notification_id) {
                has = true;
            }
        }
        return has;
    };

    $scope.list = function(page) {
        $scope.pagination.currentPage = page;
        $scope._init();
    };

    $scope.setPage = function(){
        $scope._init();
    };

    $scope.onFilter = function() {

    };

    $scope.delete = function() {
        $scope.showLoader = true;

        var ids = [];
        for (var i = 0; i < $scope.rows.length; i++) {
            if ($scope.rows[i].checked)
                ids.push($scope.rows[i].id);
        }

        var promise = systemApiService.delete(ids);
        promise.then(
            function(payload) {
                if (payload.data.code) {
                    $scope.showLoader = false;
                    $rootScope.notification.show('success', payload.data.msg);
                    $scope.clearFilters();
                    $rootScope.checkboxList.clear();
                } else {
                    $scope.showLoader = false;
                    $rootScope.notification.show('error', payload.data.msg);
                }
            });
    };
});
